export const FORM_FIELD_NAMES = {
    ENABLED: "enabled",
    CASINO_FEE: "casinoFee",
    SPORT_FEE: "sportFee"
}